// Define environment-specific URLs
const DEV_API_URL = process.env.REACT_APP_DEV_API_URL || 'http://localhost:3000';
const PROD_API_URL = process.env.REACT_APP_PROD_API_URL || 'https://api.eprorab.com';

// Export the environment-specific URL based on current environment
export const REACT_APP_API_URL = process.env.NODE_ENV === 'development' ? DEV_API_URL : PROD_API_URL;

// Log configuration for debugging
console.log('config.js: Environment:', process.env.NODE_ENV === 'development' ? 'Development' : 'Production');
console.log('config.js: API URL:', REACT_APP_API_URL);

// Export the configuration object for use throughout the app
export const API_CONFIG = {
  baseURL: REACT_APP_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
}; 